import { getTokenFromLocalStorage } from '@/auth';
import useIntl from '@/hooks/useIntl';
import EndingPoliciesNotification from '@/services/EndingPoliciesNotification';
import { useModel } from '@umijs/max';
import { useEffect } from 'react';

const EndingPoliciesNotifier: React.FC = () => {
    const { setInitialState } = useModel('@@initialState');
    const t = useIntl();

    useEffect(() => {
        init();

        const onRefresh = () => init({ skipPopup: true });
        const onPageChange = () => init();

        window.addEventListener(EndingPoliciesNotification.refreshEvent, onRefresh);
        window.addEventListener(EndingPoliciesNotification.pageChangeEvent, onPageChange);

        return () => {
            window.removeEventListener(EndingPoliciesNotification.refreshEvent, onRefresh);
            window.removeEventListener(EndingPoliciesNotification.pageChangeEvent, onPageChange);
        };
    }, []);

    const init = async (options?: { skipPopup?: boolean }) => {
        if (!getTokenFromLocalStorage()) return;

        const result = await EndingPoliciesNotification.fetchIfNeeded();

        if (!result) return;

        await setInitialState((prev) => {
            if (prev?.endingPoliciesCount === result.data.totalCount) return prev;

            return {
                ...prev,
                endingPoliciesCount: result.data.totalCount,
            };
        });

        if (options?.skipPopup) {
            EndingPoliciesNotification.markPopupShown();
            return;
        }

        if (EndingPoliciesNotification.shouldShowPopup(result.data, result.popupShown)) {
            EndingPoliciesNotification.showPopup(result.data, t);
        }
    };

    return null;
};

export default EndingPoliciesNotifier;
